import { AdviseCurrentSuppliers, MatrixCriterion } from '../../../../types/advise';
import { selectedFeatures } from '../../../../utils/adviseMatrix';

export type StepStatus = 'not_started' | 'in_progress' | 'complete';

export const STEP_STATUS_LABELS: Record<StepStatus, string> = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  complete: 'Complete'
};

// Complete once a selected criterion has a ticked feature: the sheets and the report have something to ask about.
export const functionalityMatrixStepStatus = (criteria: MatrixCriterion[] | null): StepStatus | undefined => {
  if (!criteria) return undefined;
  return selectedFeatures(criteria).length > 0 ? 'complete' : 'not_started';
};

export const supplierSelectionStepStatus = (selected?: string[] | null): StepStatus =>
  selected && selected.length > 0 ? 'complete' : 'not_started';

export const currentSuppliersStepStatus = (current?: AdviseCurrentSuppliers | null): StepStatus => {
  if (!current) return 'not_started';
  if (current.skipped) return 'complete';
  const suppliers = current.suppliers ?? [];
  if (suppliers.length === 0) return 'not_started';
  return suppliers.every((supplier) => supplier.complete) ? 'complete' : 'in_progress';
};
